module.exports = __webpack_public_path__ + "media/images/flags/gq-895503a46b73113a6b59f09bd366bd24.svg";